import BaseProxy from "../../base-proxy";
import LocalStoreManager from "@/utilities/local-store-manager";
import ValidationHelper from "@/utilities/validation-helper";
import { preventDuplicatedRequest } from "@/utilities/async-for-each";

const TARGET_URL = "/companies/";

/**
 * @class GetCompanyProxy
 * @description Class used for communicating GET requests with company API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since November 29, 2018
 */
export default class GetCompanyProxy {
  /**
   * @async
   * @function execute
   * @param input - Input parameter instance.
   * @param {String} input.id - Company id.
   * @param {String} input.authToken - Token used for issuing authenticated request.
   */
  async execute(input = {}) {
    let baseProxy = new BaseProxy();
    if (!input.authToken) {
      return {};
    }
    let queryString = "";

    if (input.load) {
      queryString = input.load.map((value) => `load[]=${encodeURIComponent(value)}`).join("&");
    }

    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}${TARGET_URL}${input.id}?${queryString}`;

    let company = await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
    let store = new LocalStoreManager();
    let validator = new ValidationHelper();
    store.setCompanyStatus(company.status);
    store.setCompanySubStatus(company.sub_status);
    store.setNeedsToPayForCompany(validator.getTruthyOrNull(company.expected_external_payment_info));
    store.setMicroserviceEnable(company.microservice_enabled);
    return company;
  }

  async getCompanySelectedServices(input = {}) {
    return preventDuplicatedRequest("getCompanySelectedServices", async () => {
      let baseProxy = new BaseProxy();

      if (!input.authToken) {
        return {};
      }

      let backendUrl = await baseProxy.getBackendUrl();
      let endpointUrl = `${backendUrl}${TARGET_URL}${input.id}`;

      let company = await baseProxy.getAuthenticatedData(endpointUrl, input.authToken);
      return company.selected_services;
    });
  }
}
